export default {
  id: 0,
  newPassword: null,
  currentPassword: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/changepasswordmodel.js